var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliverImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 380,
    viewBox: "0 0 488 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3953_37642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.856 398.321C20.6388 397.591 16.3847 393.597 15.4551 388.307L-19.9976 186.874C-21.304 179.444 -15.5634 172.641 -7.98878 172.641H2.54611L2.55449 172.695H-7.43609C-12.737 172.695 -16.7651 177.443 -15.8732 182.65L19.7051 390.091C20.3332 393.756 22.6864 396.757 25.856 398.321Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.441 271.003L117.848 250.496M112.103 217.445L105.916 182.4C104.932 176.788 100.041 172.694 94.3176 172.694H-7.43876C-12.7397 172.694 -16.7678 177.443 -15.8759 182.65L19.7024 390.091C20.3305 393.755 22.6837 396.757 25.8534 398.32C27.3775 399.075 29.0942 399.496 30.8947 399.496H129.444C137.018 399.496 142.767 392.688 141.461 385.259L135.371 350.503",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3479 183.836H37.738C36.0037 183.836 34.5977 182.437 34.5977 180.71C34.5977 178.983 36.0037 177.583 37.738 177.583H60.3479C62.0822 177.583 63.4883 178.983 63.4883 180.71C63.4883 182.437 62.0822 183.836 60.3479 183.836Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.76 339.911C112.675 359.946 112.593 379.386 112.508 399.421C100.894 399.345 89.2797 399.27 77.6655 399.194C76.6556 383.919 75.6456 368.643 74.6357 353.368C70.495 368.719 66.3543 384.07 62.2136 399.421C51.5985 399.394 40.9833 399.367 30.3682 399.339C29.5334 399.321 27.9543 399.171 26.2808 398.241C25.1399 397.606 24.3625 396.835 23.8867 396.278C31.1034 369.052 38.0717 342.764 45.2884 315.538",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0076 339.778L75.7421 345.599L74.125 354.752L85.0076 339.778Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2658 222.013L91.1728 224.37C91.1309 222.633 91.0849 220.778 91.043 219.04C92.9146 219.517 94.7528 220.133 96.524 220.941C97.1395 221.222 97.7717 221.557 98.2658 222.013Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0134 217.103C76.6114 221.102 76.2806 225.213 75.8828 229.212L70.0082 231.092L52.5938 220.377C52.5352 220.34 52.4683 220.344 52.418 220.373C52.5562 219.594 52.9036 218.857 53.4731 218.233C54.8716 216.697 57.1118 216.337 59.0839 216.186C64.5104 215.776 69.9538 216.462 75.3762 216.956C75.9205 217.007 76.4648 217.053 77.0134 217.103Z",
    fill: "#758B9A",
    stroke: "#758B9A",
    strokeWidth: 0.418716,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1932 288.254C84.5314 272.921 81.9737 253.991 81.2122 242.565C79.5038 241.769 76.8742 240.295 74.3452 237.666C72.0171 235.25 70.6814 232.796 69.9319 231.125C69.9194 231.1 69.911 231.075 69.8984 231.05",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7643 274.167L92.7734 240.898C92.7734 240.898 96.6633 236.711 97.9781 232.113C99.2635 227.604 98.6313 223.781 98.2251 222.026C98.2251 222.026 137.852 209.423 161.2 202.041C161.97 202.585 165.107 209.26 169.411 217.203C171.128 220.377 169.851 224.338 166.61 225.912L111.913 252.463L114.145 267.139",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4218 220.372V220.376C52.3758 220.397 52.3423 220.447 52.3381 220.51L52.045 227.063C51.9529 229.157 52.8029 231.179 54.3605 232.578L56.9733 234.927L46.7105 238.054C41.8032 239.549 37.9594 243.372 36.4311 248.267L24.1878 287.555C21.194 297.165 26.0343 307.469 35.3424 311.296L74.4421 327.375",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.211 203.683C159.674 211.043 163.136 218.403 166.599 225.764",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.855 219.523L169.228 216.538",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.727 213.275L166.157 210.578",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.371 208.263L163.632 205.755",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6602 288.255C54.1176 278.391 57.444 266.532 59.9015 256.668",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9727 234.926C61.4118 233.538 65.851 232.217 70.2902 230.83",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.129 252.419L109.086 245.815",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4297 322.493L68.0103 324.732L45.2731 315.538L43.4297 322.493Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1732 303.753L51.6602 288.254",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.097 195.494C180.454 194.946 180.951 194.16 181.506 193.194C183.259 190.142 184.18 187.754 184.586 186.629C184.962 185.587 185.807 183.109 185.495 180.57C185.432 180.061 185.307 179.417 184.939 179.307C184.355 179.133 183.501 180.413 183.223 180.822C180.219 185.233 172.318 193.746 169.02 196.903C167.773 198.096 165.816 199.834 163.125 201.677L169.891 218.341C171.074 217.679 172.733 216.596 174.386 214.907C174.757 214.528 175.834 213.397 177.315 211.07C178.76 208.798 181.005 205.201 181.859 200.263C182.02 199.336 182.686 195.483 181.569 195.004C181.44 194.949 181.197 194.9 180.496 195.264C179.731 195.661 178.489 196.516 177.213 198.9C176.719 199.824 176.102 201.199 175.699 202.99",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.207 202.107L165.745 199.75C165.745 199.75 170.745 217.699 169.892 218.342C166.661 212.299 161.207 202.107 161.207 202.107Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4182 206.872C73.1236 207.023 71.8432 207.715 71.3352 209.182C71.2312 209.483 70.7885 210.887 71.676 212.274C71.872 212.58 72.9679 214.19 74.8952 214.143C76.3632 214.106 77.4361 212.308 77.9128 210.882C77.1795 210.649 76.2317 210.289 75.5846 209.579C74.503 208.394 73.5847 207.772 73.4182 206.872Z",
    fill: "#6AD67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1398 211.877C97.7797 212.89 96.557 213.439 94.1536 214.511C92.8765 215.085 91.7585 215.415 90.9671 215.616C90.9965 216.759 91.0216 217.898 91.0509 219.041C91.0928 220.72 91.1304 222.404 91.1723 224.083C91.2477 224.702 91.9218 231.77 85.2894 233.152C78.3512 234.597 75.9 229.165 75.9 229.165C76.2978 225.166 77.4124 213.124 77.6051 211.198C74.3977 209.121 72.5227 206.79 73.0377 205.048C73.0712 204.939 73.3141 204.16 74.0259 203.8C74.8885 203.365 75.4825 203.248 77.3388 204.312L76.2567 203.761L86.1443 195.348L88.6475 198.65C89.6022 199.893 91.0928 201.79 92.9896 204.051C96.8878 208.707 98.6799 210.345 98.1398 211.877Z",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9375 203.61C76.9042 204.75 78.753 205.108 80.1375 204.797C81.8468 204.413 83.1311 202.803 83.1582 200.896C83.7776 201.04 84.8415 201.227 86.1501 201.123C86.7846 201.073 91.1387 200.728 92.1719 197.942C92.2569 197.713 92.5723 196.855 92.2854 195.897C91.7623 194.15 90.7839 192.92 87.902 192.997C84.4647 196.474 79.3748 200.132 75.9375 203.61Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5938 206.152C75.862 206.498 76.195 206.879 76.6037 207.263C77.167 207.793 77.7211 208.187 78.1944 208.475",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8711 203.852C87.3507 204.66 87.8531 205.174 88.2345 205.499C88.5434 205.762 88.8729 205.987 89.0298 206.427C89.1784 206.844 89.1018 207.256 89.0109 207.544",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6523 209.854C83.9797 210.127 84.6822 210.637 85.7164 210.839C86.5547 211.003 87.251 210.895 87.6478 210.801",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4219 206.976C82.4364 206.847 82.506 206.372 82.9142 206.01C83.1741 205.779 83.4528 205.699 83.5959 205.669",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0469 202.546C88.0786 202.419 88.1916 202.038 88.5582 201.769C88.7517 201.627 88.9448 201.568 89.0695 201.542",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1904 222.892L84.5018 218.932C83.7867 218.457 83.9448 217.364 84.7651 217.112C86.8386 216.474 91.0024 215.189 91.0024 215.189L91.1904 222.892Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2741 209.038C72.6253 208.38 71.0792 206.629 70.7745 204.001C70.3727 200.536 72.416 197.989 73.1226 197.108C77.8296 191.24 87.541 193.114 87.938 193.196C88.9208 192.427 89.9164 191.627 90.9226 190.796C91.8866 190 92.8207 189.208 93.7252 188.423C94.5956 188.832 95.2405 190.086 95.2135 190.882C95.1517 192.703 93.8992 194.194 90.203 196.54C89.8396 196.344 89.2637 196.096 88.5367 196.048C88.1867 196.025 86.8442 195.984 84.9009 197.525C83.3307 198.77 83.1404 199.642 81.909 201.047C81.0929 201.979 79.5611 203.291 77.3924 204.345",
    fill: "#6AD67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2741 209.038C72.6253 208.38 71.0792 206.629 70.7745 204.001C70.3727 200.536 72.416 197.989 73.1226 197.108C77.8296 191.24 87.541 193.114 87.938 193.196C88.9208 192.427 89.9164 191.627 90.9226 190.796C91.8866 190 92.8207 189.208 93.7252 188.423C94.5956 188.832 95.2405 190.086 95.2135 190.882C95.1517 192.703 93.8992 194.194 90.203 196.54C89.8396 196.344 89.2637 196.096 88.5367 196.048C88.1867 196.025 86.8442 195.984 84.9009 197.525C83.3307 198.77 83.1404 199.642 81.909 201.047C81.0929 201.979 79.5611 203.291 77.3924 204.345",
    stroke: "#6AD67D",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4492 305.048L104.548 262.625L176.96 298.528L148.404 355.791L108.115 337.343",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.168 276.318C122.17 295.944 114.209 311.57 104.211 331.196",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2969 313.074L108.936 283.455C108.936 283.455 124.419 278.697 132.161 276.318",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.939 283.456C107.499 276.689 106.06 269.923 104.621 263.156",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4 295.499L154.953 302.341L166.315 307.732L169.799 301.104L158.4 295.499Z",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.895 305.033L164.38 310.431",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2695 301.373C85.695 288.457 95.1206 275.541 104.546 262.625C97.1657 276.811 89.7854 290.997 82.4051 305.183C80.3599 303.913 78.3147 302.643 76.2695 301.373Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1914 308.936C87.2906 309.55 98.8835 316.707 99.9397 317.481C101.018 318.27 105.589 320.851 105.002 323.363C104.921 323.71 104.586 324.108 104.523 324.171C103.768 324.913 101.857 324.084 101.05 323.734C99.8985 323.234 98.4826 321.899 96.8836 320.581",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.708 320.151C97.7565 322.746 98.9607 324.603 99.8521 325.806C102.671 329.61 106.357 333.639 106.357 333.639C106.357 333.639 108.519 336.005 108.11 337.345C107.941 337.895 107.566 338.159 107.566 338.159C107.566 338.159 107.273 338.365 106.85 338.393C104.759 338.535 102.131 335.999 102.131 335.999C100.686 334.604 98.5105 332.267 96.1445 328.709",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5312 329.307C92.4346 331.547 93.5447 333.177 94.3837 334.237C95.698 335.898 97.5993 338.3 100.23 338.674C101.631 338.873 103.017 338.561 103.017 338.561C103.757 338.394 104.351 338.145 104.773 337.935",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6328 330.575C87.9381 332.346 89.1008 333.718 89.9784 334.696C90.1955 334.937 91.0331 335.864 92.2792 336.891C93.3719 337.791 93.8641 338.016 94.2396 338.147C95.3607 338.538 96.3238 338.404 96.5991 338.358C97.2366 338.252 97.7317 338.034 98.0514 337.864",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4102 327.479L84.721 334.074C84.721 334.074 86.5088 335.597 88.9393 336.435C89.342 336.574 89.8741 336.697 90.473 336.563C90.8278 336.483 91.098 336.337 91.2672 336.229",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0234 324.984C72.8147 317.885 76.5039 310.977 80.2952 303.878C82.0094 304.898 83.5936 306.081 85.2428 307.182C86.1777 307.806 86.4643 309.052 85.9065 310.028C83.9433 313.464 82.0312 316.835 80.1057 320.223C78.9627 322.234 77.815 324.252 76.649 326.292C76.1023 327.248 74.9157 327.641 73.9118 327.187C72.2835 326.45 70.681 325.665 69.0234 324.984Z",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5977 308.936C79.7857 310.081 82.0245 311.253 84.2125 312.399",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8398 314.094C77.069 315.271 79.2982 316.448 81.5274 317.626",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7891 319.804C74.0013 320.984 75.9704 322.034 78.1827 323.214",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5 363.67L218.712 399.419H285.005L263.493 348.294",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.418 349.134C246.797 365.946 252.176 382.758 257.556 399.57",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.324 359.507C228.633 360.291 233.955 373.272 244.153 374.044C245.499 374.145 247.206 374.056 249.195 373.427",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.173 204.955C187.291 204.443 188.903 197.16 185.709 195.108C185.61 195.045 184.243 194.189 183.335 194.704C182.502 195.177 182.655 196.466 182.149 199.375C182.149 199.375 181.974 200.377 181.442 202.557C181.072 204.071 180.394 206.24 179.043 208.843C178.273 211.092 178.29 212.959 178.386 214.044C178.568 216.091 179.227 217.583 179.851 218.993C180.596 220.679 181.735 222.863 182.379 223.76L194.596 215.913C194.243 215.522 193.753 214.942 193.235 214.19C192.745 213.48 192.079 212.568 191.768 211.52C191.435 210.396 191.495 209.478 191.667 207.934C192.054 204.466 192.449 202.857 192.778 200.107C192.974 198.472 193.072 197.655 193.081 196.674C193.104 194.185 192.637 192.68 191.718 189.15C189.916 182.233 189.401 179.148 188.334 179.151C188.218 179.152 188.136 179.189 188.032 179.238C186.501 179.957 186.536 183.384 186.617 187.029C186.697 190.579 186.81 193.764 186.93 196.518",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.141 223.761L193.615 213.305L196.408 216.411L182.141 223.761Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.092 281.847L204.419 221.115L184.234 231.318C181.574 232.663 180.532 235.926 181.92 238.563L210.588 291.661",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.978 231.241L180.227 224.978L201.056 214.146L204.147 221.013L183.978 231.241Z",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.964 281.086C216.796 281.944 209.143 290.082 208.947 299.228L208.095 339.127L170.602 344.732L174.485 367.243C175.005 370.26 177.982 372.196 180.951 371.45L227.629 359.709C232.477 358.489 235.975 354.267 236.272 349.277L265.096 348.611C266.792 348.571 268.474 348.923 270.012 349.637L231.149 274.208",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.555 348.883C264.568 351.18 265.581 353.476 266.594 355.773C267.263 355.482 269.904 354.254 270.504 351.914C270.61 351.499 270.831 350.639 270.379 349.949C270.029 349.415 269.454 349.256 268.628 349.04C268.219 348.933 267.426 348.762 264.764 348.836C264.255 348.85 263.837 348.869 263.555 348.883Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.383 345.915C164.413 353.626 165.444 361.336 166.475 369.047C169.171 368.569 171.641 368.077 174.337 367.599C173.017 359.972 171.752 352.596 170.432 344.97C168.025 345.364 165.789 345.521 163.383 345.915Z",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.277 339.398C207.993 339.114 209.709 338.83 211.425 338.546",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.272 349.277C236.293 348.361 236.3 347.225 236.267 345.919C236.267 345.919 236.25 345.267 236.221 344.606C236.071 341.236 232.369 316.376 232.9 316.259C233.115 316.212 234.163 320.216 236.158 327.841C238.003 334.89 239.163 339.648 239.63 341.576C240.369 344.627 240.974 347.212 241.419 349.135C239.703 349.182 237.987 349.229 236.272 349.277Z",
    fill: "#758B9A",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.597 347.492C159.963 347.867 156.52 348.02 152.313 348.101C147.987 348.185 143.932 348.064 140.19 347.815C139.792 347.789 139.5 348.188 139.655 348.555C139.715 348.696 139.786 348.844 139.87 348.996C140.643 350.387 142.013 351.127 146.317 352.608C147.374 352.972 148.743 353.427 150.356 353.921C149.67 354.403 148.367 355.298 146.67 356.319C138.148 361.45 131.318 362.774 131.293 365.637C131.292 365.834 131.293 366.172 131.518 366.446C132.445 367.58 135.949 366.134 141.141 363.818C144.033 362.528 147.766 360.827 152.124 358.743",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.262 366.252C135.348 366.841 135.568 367.657 136.216 368.203C137.529 369.307 139.885 368.704 145.421 366.355C147.822 365.336 151.06 363.888 154.852 361.962",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.422 367.934C141.54 368.364 141.816 369.098 142.5 369.575C142.5 369.575 143.177 370.046 144.242 370.029C145.835 370.003 150.748 367.969 157.119 364.613",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.823 368.6C148.799 368.959 148.825 369.474 149.147 369.866C149.916 370.802 151.983 370.551 157.312 368.704C159.524 367.937 162.314 366.991 165.984 365.351",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.594 347.289L161.258 367.045L166.285 364.941L163.594 347.289Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.742 343.099C149.688 344.403 144.667 346.359 139.613 347.663C141.107 348.619 152.265 347.947 152.265 347.947L154.742 343.099Z",
    fill: "#758B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.96 281.535C222.893 278.132 215.28 285.649 215.28 285.649C215.28 285.649 214.381 275.467 214.037 273.801C213.338 273.332 212.689 272.942 212.111 272.62C208.636 270.69 205.093 269.815 204.511 267.093C204.327 266.235 204.461 265.427 204.461 265.427C204.645 264.313 205.169 263.953 206.006 262.458C206.835 260.976 207.25 260.239 207.133 259.418C206.99 258.4 205.809 258.036 205.902 256.943C205.91 256.818 205.931 256.583 206.065 256.345C206.638 255.348 208.276 255.989 209.712 255.302C210.516 254.917 210.675 254.398 212.312 251.462C212.802 250.587 214.599 247.628 215.528 246.074C215.528 246.074 240.627 283.585 233.96 281.535Z",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.516 256.88C211.71 257.094 211.995 257.36 212.384 257.599C212.936 257.936 213.458 258.07 213.798 258.129",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.746 260.68C217.919 260.739 218.292 260.84 218.756 260.756C219.177 260.679 219.471 260.486 219.614 260.377",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.586 262.093C209.754 262.174 210.086 262.306 210.52 262.295C211.044 262.282 211.422 262.069 211.581 261.967",
    stroke: "#758B9A",
    strokeWidth: 0.837433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.915 246.01C214.728 246.148 212.754 247.645 212.516 249.949C212.157 253.426 215.863 257.672 219.157 258.003C219.781 258.066 220.775 258.026 221.555 258.735C222.228 259.346 222.596 260.38 222.439 261.31C222.228 262.555 221.211 262.814 220.293 264.012C218.897 265.834 219.036 268.123 219.106 269.289C219.299 272.478 221.133 274.656 222.06 275.727C228.205 282.825 240.928 282.848 243.218 279.654C243.424 279.366 243.572 279.035 243.572 279.035C244.739 276.418 242.491 273.158 241.816 272.118C236.455 263.856 238.535 254.1 230.064 248.131C225.62 245 218.708 243.216 214.915 246.01Z",
    fill: "#6AD67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.711 279.954L219.347 276.383L214.035 273.353L214.711 279.954Z",
    fill: "#758B9A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H480C484.418 0 488 3.58172 488 8V68H0V8Z",
    fill: "#263743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4915 23.557C59.4915 23.6371 59.4371 23.6979 59.358 23.7121L50.7019 24.932C51.175 26.4672 51.7103 28.8114 51.0739 31.5872C50.5386 33.9159 49.2384 35.8453 47.3123 37.1673C45.2863 38.5552 43.1021 38.9467 41.5674 38.8899L31.6202 48.8107H26.25L37.1655 37.9258C35.4765 37.25 33.8445 36.2381 32.4278 34.9575C25.7535 28.938 25.7717 20.3676 27.0135 14.25L42.9012 28.2338V33.1315L30.1827 21.9378C30.3098 24.8389 31.2404 28.9368 34.8919 32.2372C37.3236 34.4328 40.4034 35.5519 42.9323 35.1487C45.2461 34.783 46.9882 33.125 47.4782 30.8235C48.0213 28.2699 47.2228 25.9632 45.1152 24.1605L47.5495 21.7362L59.3593 23.4045C59.4384 23.4148 59.4928 23.4782 59.4928 23.557H59.4915Z",
    fill: "#6AD67D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 68.5H487.5V372C487.5 376.142 484.142 379.5 480 379.5H7.99999C3.85786 379.5 0.5 376.142 0.5 372V68.5Z",
    stroke: "#263743"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3953_37642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 320,
    fill: "white",
    transform: "translate(0 60)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverImg);
export default __webpack_public_path__ + "static/media/deliver_img.70beb1cb6e61204a93aee6ad37d44d6e.svg";
export { ForwardRef as ReactComponent };